import { Navigate } from "react-router-dom";
import { useAuth, isRealUser } from "../../../auth/AuthContext";

export function ProtectedRoute({ children, rejectAnonymous }: { children: React.ReactNode; rejectAnonymous?: boolean }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (rejectAnonymous && !isRealUser(user)) return <Navigate to="/register" replace />;
  return <>{children}</>;
}
